import * as React from "react";
const MenuPercent = (props) => (
  <svg
    width={19}
    height={23}
    viewBox="0 0 19 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.75977 22.25C8.96977 22.25 8.21977 21.85 7.69977 21.14L6.68977 19.79C6.47977 19.51 6.19977 19.35 5.89977 19.33C5.59977 19.31 5.29977 19.45 5.05977 19.7L4.48977 19.2L5.03977 19.71C3.58977 21.25 2.48977 21.13 1.95977 20.92C1.41977 20.71 0.509766 20.02 0.509766 17.8V6.54C0.509766 2.1 1.78977 0.75 5.97977 0.75H13.5298C17.7198 0.75 18.9998 2.1 18.9998 6.54V17.8C18.9998 20.01 18.0898 20.7 17.5498 20.92C17.0198 21.13 15.9198 21.25 14.4698 19.71C14.2298 19.45 13.9198 19.32 13.6198 19.34C13.3198 19.36 13.0298 19.52 12.8198 19.8L11.8098 21.15C11.2998 21.85 10.5498 22.25 9.75977 22.25ZM5.83977 17.83C5.87977 17.83 5.92977 17.83 5.96977 17.83C6.70977 17.87 7.40977 18.26 7.87977 18.89L8.89977 20.24C9.38977 20.89 10.1398 20.89 10.6298 20.24L11.6398 18.89C12.1098 18.26 12.8098 17.87 13.5598 17.83C14.3098 17.79 15.0398 18.1 15.5798 18.68C16.3398 19.49 16.8298 19.59 17.0098 19.52C17.2498 19.42 17.5098 18.84 17.5098 17.8V6.54C17.5098 2.93 16.8798 2.25 13.5398 2.25H5.97977C2.63977 2.25 2.00977 2.93 2.00977 6.54V17.8C2.00977 18.85 2.26977 19.43 2.50977 19.52C2.68977 19.59 3.17977 19.49 3.93977 18.68C4.45977 18.13 5.13977 17.83 5.83977 17.83Z"
      fill="#4B5155"
    />
    <path
      d="M12.7598 13.5C12.1998 13.5 11.7598 13.05 11.7598 12.5C11.7598 11.95 12.2098 11.5 12.7598 11.5C13.3098 11.5 13.7598 11.95 13.7598 12.5C13.7598 13.05 13.3198 13.5 12.7598 13.5Z"
      fill="#4B5155"
    />
    <path
      d="M6.75977 8.5C6.19977 8.5 5.75977 8.05 5.75977 7.5C5.75977 6.95 6.20977 6.5 6.75977 6.5C7.30977 6.5 7.75977 6.95 7.75977 7.5C7.75977 8.05 7.31977 8.5 6.75977 8.5Z"
      fill="#4B5155"
    />
    <path
      d="M6.39008 14.0498C6.20008 14.0498 6.01008 13.9798 5.86008 13.8298C5.57008 13.5398 5.57008 13.0598 5.86008 12.7698L12.5901 6.03977C12.8801 5.74977 13.3601 5.74977 13.6501 6.03977C13.9401 6.32977 13.9401 6.80977 13.6501 7.09977L6.92008 13.8298C6.78008 13.9798 6.59008 14.0498 6.39008 14.0498Z"
      fill="#4B5155"
    />
  </svg>
);
export default MenuPercent;